import { IConfigsType } from '../../types'

const dhFlash: IConfigsType = {
  dh_wb: {
    '/:brand/flash': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'dh/flash',
        width: '3400px',
        height: '1000px',
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'flash',
        sendStoreId: false,
      },
    },
  },
}

export default dhFlash
